/* eslint-disable no-await-in-loop */
import axios from 'axios';
import { get } from 'idb-keyval';

import keycloak from '../Keycloak';

const appTokenInterceptor = async (config) => {
  const token = await get('token');
  const kc = await keycloak;

  if (kc.authenticated) {
    if (kc.isTokenExpired(5)) {
      return kc.logout({ redirectUri: `${window.location.origin}/login` });
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }

    if (kc.idToken) {
      config.headers.Authorization = `Bearer ${kc.idToken}`;
      return config;
    }
  }

  return config;
};

const baseURLInterceptor = async (config, options, url) => {
  let newUrl = url;

  if (!options?.is_account_parent) {
    let currCompany;
    // await in loop is problematic
    while (!currCompany) currCompany = await get('currentCompany');
    newUrl = `${url}/account/${currCompany?.id}`;
  }

  config = {
    ...config,
    baseURL: newUrl
  };

  return config;
};

export default function ApiCore(
  url = '',
  options = { is_account_parent: false, params: {}, headers: {} }
) {
  const api = axios.create({
    params: options?.params,
    headers: {
      Accept: 'application/json, */*',
      'content-type': 'Application/json',
      ...options?.headers
    }
  });

  api.interceptors.request.use((config) =>
    baseURLInterceptor(config, options, url)
  );

  api.interceptors.request.use(appTokenInterceptor);

  // TODO: warning & errors messages
  return api;
}
